import { registerPlugin } from "@capacitor/core";
import type { PluginListenerHandle } from "@capacitor/core";

// ── Interfaces dupliquées depuis operator-mobile/native/video-bridge ──────────
// (La console ne doit pas importer hors de src/operator/.)

export interface TakeoverOptions {
  relayUrl: string;
  sessionCode: string;
  token: string;
}

export interface ViewportRect {
  x: number;
  y: number;
  width: number;
  height: number;
  /** Ratio de pixels du device (window.devicePixelRatio) — informatif. */
  dpr?: number;
}

export type PointerPhase = "down" | "move" | "up";

export interface PointerInput {
  phase: PointerPhase;
  x: number;
  y: number;
  button?: number;
}

export type KeyPhase = "down" | "up";

export interface KeyInput {
  phase: KeyPhase;
  code: string;
}

export type SpecialCombo = "ctrl-alt-del" | "escape" | "win" | "alt-tab" | "ctrl-c" | "ctrl-v";

export type BridgeState = "idle" | "connecting" | "streaming" | "error";

export interface StateChangeEvent {
  state: BridgeState;
  detail?: string;
}

export interface VideoBridgePlugin {
  start(options: TakeoverOptions): Promise<void>;
  stop(): Promise<void>;
  setViewport(rect: ViewportRect): Promise<void>;
  sendPointer(ev: PointerInput): Promise<void>;
  sendKey(ev: KeyInput): Promise<void>;
  sendSpecial(options: { combo: SpecialCombo }): Promise<void>;
  addListener(eventName: "stateChange", listenerFunc: (event: StateChangeEvent) => void): Promise<PluginListenerHandle>;
  removeAllListeners(): Promise<void>;
}

// ── Plugin registration ───────────────────────────────────────────────────────

export const VideoBridge = registerPlugin<VideoBridgePlugin>("VideoBridge");

// ── Helper ────────────────────────────────────────────────────────────────────

// isNativeApp est défini dans native.ts (origine unique) ; ré-export pour les
// consommateurs du module video-bridge.
export { isNativeApp } from "./native";
